import axios from "@/axios/axios";
import { AccountDocument } from "@/interfaces/account.interfaces";

export async function getAccountData(dbid: string): Promise<AccountDocument | null> {
  try {
    const res = await axios.get(`/masteracc/account/${dbid}`)
    return res ? res.data : null
  } catch (e: any) {
    console.log('getAccountData failed', e.message)
    return null
  }
}
